import { render, staticRenderFns } from "./warehoseUdiReview.vue?vue&type=template&id=ab5a51fc&"
import script from "./warehoseUdiReview.vue?vue&type=script&lang=js&"
export * from "./warehoseUdiReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports